import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="extension-request"
export default class extends Controller {
  static targets = ["extensionTypeInput", "policyStartHiddenInput", "policyEndHiddenInput"];

  connect() {
    // since the date inputs are defined as one input in .erb files we cannot pass them as targets (without the additional changes)
    // so define them here via the selectors
    this.newStartYearInput = document.getElementById('extension_request_new_start_date_1i');
    this.newStartMonthInput = document.getElementById('extension_request_new_start_date_2i');
    this.newStartDayInput = document.getElementById('extension_request_new_start_date_3i');

    this.newFinishYearInput = document.getElementById('extension_request_new_finish_date_1i');
    this.newFinishMonthInput = document.getElementById('extension_request_new_finish_date_2i');
    this.newFinishDayInput = document.getElementById('extension_request_new_finish_date_3i');
  }

  // We don't want to force trigger this on page load, since if the user is going back (or dealing with an error)
  // we want to leave the fields alone.
  maybeResetPolicyDates() {
    if (this._isDefer()) {
      const policyStart = new Date(this.policyStartHiddenInputTarget.value);
      const policyEnd = new Date(this.policyEndHiddenInputTarget.value);

      // Reset to the base policy dates
      this.newStartYearInput.value = policyStart.getUTCFullYear();
      this.newStartMonthInput.value = policyStart.getUTCMonth() + 1;
      this.newStartDayInput.value = policyStart.getUTCDate();

      this.newFinishYearInput.value = policyEnd.getUTCFullYear();
      this.newFinishMonthInput.value = policyEnd.getUTCMonth() + 1;
      this.newFinishDayInput.value = policyEnd.getUTCDate();
    }
  }

  updateDeferredFinish() {
    if (this._isDefer()) {
      // Update the finish date to be inline with the change made
      const policyStart = new Date(this.policyStartHiddenInputTarget.value);
      const policyEnd = new Date(this.policyEndHiddenInputTarget.value);

      let newPolicyStart = new Date(policyStart.getTime());
      newPolicyStart.setUTCDate(this.newStartDayInput.value);
      newPolicyStart.setUTCMonth(parseInt(this.newStartMonthInput.value) - 1);
      newPolicyStart.setUTCFullYear(this.newStartYearInput.value);
      const newPolicyEnd = new Date(policyEnd.getTime() + (newPolicyStart.getTime() - policyStart.getTime()));

      this.newFinishYearInput.value = newPolicyEnd.getUTCFullYear();
      this.newFinishMonthInput.value = newPolicyEnd.getUTCMonth() + 1;
      this.newFinishDayInput.value = newPolicyEnd.getUTCDate();
    }
  }

  _selectedExtensionType() {
    return this.extensionTypeInputTargets.find(input => input.checked)?.value;
  }

  _isDefer() {
    return this._selectedExtensionType() === 'defer';
  }
}
